import { base } from 'api';

const PATH = '/app-routes';

const getAll = () => base.get(PATH);

export { getAll };
